module.exports = __webpack_public_path__ + "static/media/muli-latin-800.47fd62e6.woff";